import { Check, Loader2 } from "lucide-react";

const Opt = ({ active, onClick, children, testid, hint }) => (
  <button onClick={onClick} data-testid={testid}
    className={`flex w-full items-center gap-2 rounded-md px-3 py-1.5 text-left text-xs transition-colors hover:bg-white/10 ${active ? "text-amber-300" : "text-white/85"}`}>
    <Check size={12} className={active ? "opacity-100" : "opacity-0"} />
    <span className="flex-1 truncate">{children}</span>
    {hint && <span className="font-mono text-[9px] uppercase text-white/40">{hint}</span>}
  </button>
);

const Section = ({ title, children, busy }) => (
  <div className="border-b border-white/5 py-2 last:border-0">
    <p className="flex items-center gap-2 px-3 pb-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/40">
      {title}{busy && <Loader2 size={10} className="animate-spin" data-testid="player-sub-loading" />}
    </p>
    {children}
  </div>
);

const Empty = ({ children }) => <p className="px-3 py-1.5 text-xs text-white/40">{children}</p>;

export const PlayerMenu = ({ base, mode, t, onMode, onAudio, onSub }) => (
  <div onClick={(e) => e.stopPropagation()} data-testid="player-settings-menu"
    className="absolute bottom-20 right-4 z-20 max-h-[70%] w-72 overflow-y-auto rounded-xl border border-white/10 bg-zinc-950/90 p-1 text-white shadow-2xl backdrop-blur-xl animate-rise">
    {base && (
      <Section title="Playback">
        {base.direct && <Opt active={mode === "direct"} onClick={() => onMode("direct")} testid="player-mode-original" hint="raw">Original file</Opt>}
        <Opt active={mode !== "direct"} onClick={() => onMode("convert")} testid="player-mode-convert" hint={base.convert.mode === "hls" ? "plex" : "ffmpeg"}>Converted</Opt>
      </Section>
    )}
    <Section title="Audio">
      {!t.tracks ? <Empty>Reading tracks…</Empty> : !t.tracks.audio.length ? <Empty>Default track</Empty>
        : t.tracks.audio.map((a) => <Opt key={a.id} active={a.id === t.audio} onClick={() => onAudio(a)} testid={`player-audio-${a.index}`} hint={a.codec}>{a.label}</Opt>)}
    </Section>
    <Section title="Subtitles" busy={t.busy}>
      <Opt active={!t.sub} onClick={() => onSub(null)} testid="player-sub-off">Off</Opt>
      {t.tracks?.subtitles.map((s, i) => (
        <Opt key={s.id} active={s.id === t.sub} onClick={() => onSub(s)} testid={`player-sub-${i}`}
          hint={s.source === "external" ? "file" : s.kind === "image" ? "burn-in" : s.codec}>{s.label}</Opt>
      ))}
      {t.tracks && !t.tracks.subtitles.length && !t.tracks.error && <Empty>No subtitles found</Empty>}
      {t.tracks?.error && <Empty>{t.tracks.error}</Empty>}
    </Section>
  </div>
);

export const SubtitleOverlay = ({ cues, time, raised }) => {
  const c = cues.find((x) => time >= x.start && time < x.end);
  if (!c) return null;
  return (
    <div className={`pointer-events-none absolute inset-x-0 flex justify-center px-8 transition-[bottom] duration-300 ${raised ? "bottom-24" : "bottom-8"}`}>
      <p data-testid="player-subtitle-text" style={{ textShadow: "0 1px 3px #000" }}
        className="max-w-[85%] whitespace-pre-line rounded bg-black/55 px-3 py-1 text-center text-base leading-snug text-white sm:text-2xl">{c.text}</p>
    </div>
  );
};
